import { useRef } from 'react';

const FeaturesShowcase = () => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const features = [
    {
      title: 'Enterprise-Grade Security',
      metric: '99.9% Uptime Guaranteed',
      image: 'https://public.readdy.ai/ai/img_res/db6f9a3b990b3a3835b67c005a6edb13.jpg',
      bgColor: 'bg-rose-100',
    },
    {
      title: 'Scalable Cloud Infrastructure',
      metric: '3x Faster Deployment',
      image: 'https://readdy.ai/api/search-image?query=cloud%20computing%20infrastructure%20visualization%20with%20server%20racks%20data%20centers%20interconnected%20networks%20abstract%20representation%20of%20scalable%20technology%20modern%20clean%20design%20with%20soft%20sage%20green%20tones&width=1200&height=700&seq=feature-cloud-001&orientation=landscape',
      bgColor: 'bg-green-100',
    },
    {
      title: 'AI-Powered Monitoring',
      metric: '24/7 Proactive Support',
      image: 'https://readdy.ai/api/search-image?query=artificial%20intelligence%20monitoring%20system%20with%20real-time%20analytics%20predictive%20maintenance%20dashboard%20modern%20tech%20interface%20with%20warm%20gray%20tones%20clean%20professional%20visualization&width=1200&height=700&seq=feature-ai-001&orientation=landscape',
      bgColor: 'bg-gray-100',
    },
    {
      title: 'Compliance & Governance',
      metric: 'ISO 27001 Certified',
      image: 'https://readdy.ai/api/search-image?query=compliance%20and%20governance%20framework%20visualization%20with%20certification%20badges%20regulatory%20standards%20documentation%20modern%20professional%20design%20with%20terracotta%20warm%20tones%20clean%20layout&width=1200&height=700&seq=feature-compliance-001&orientation=landscape',
      bgColor: 'bg-orange-100',
    },
  ];

  return (
    <section className="py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 mb-12">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end gap-8">
          <div>
            <p className="text-sm font-semibold text-cyan-600 uppercase tracking-wider mb-2">
              Why Choose Us
            </p>
            <h2 className="text-5xl lg:text-6xl font-bold text-slate-900">
              Built for Modern<br />
              <span className="italic font-light">Enterprise Needs</span>
            </h2>
          </div>
          <p className="text-lg text-gray-600 max-w-xl">
            Our solutions are designed with enterprise requirements in mind, delivering reliability, security, and performance at scale.
          </p>
        </div>
      </div>

      <div className="relative">
        <div
          ref={scrollRef}
          className="flex gap-8 overflow-x-auto scrollbar-hide px-6 lg:px-8 snap-x snap-mandatory"
          style={{ scrollBehavior: 'smooth' }}
        >
          {features.map((feature, index) => (
            <div
              key={index}
              className="flex-shrink-0 w-[85vw] lg:w-[70vw] snap-center"
            >
              <div className={`${feature.bgColor} rounded-3xl overflow-hidden shadow-lg h-[600px] flex flex-col`}>
                <div className="flex-1 p-8 flex items-center justify-center">
                  <img
                    src={feature.image}
                    alt={feature.title}
                    className="w-full h-full object-contain rounded-xl shadow-xl"
                  />
                </div>
                <div className="bg-white/90 backdrop-blur-sm p-8">
                  <h3 className="text-2xl font-bold text-slate-900 mb-2">
                    {feature.title}
                  </h3>
                  <p className="text-base text-gray-600 font-semibold">
                    {feature.metric}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesShowcase;